import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ColorValueService {
    protected data = data;
    legend: { background: string, text: string }[] = []

    constructor() {
        this.legend = this.data.map((item) => ({
            background: `linear-gradient(90deg, ${this.makeColor(item.colorStart)} 0%, ${this.makeColor(item.colorEnd)} 100%)`,
            text: `${item.rangeStart} - ${item.rangeEnd}`
        }))
    }

    makeColor(color: { hue: number, saturation: number, lightness: number }):`hsl(${number}, ${number}%, ${number}%)` {
        return `hsl(${color.hue}, ${color.saturation * 100}%, ${color.lightness * 100}%)`
    }

    getColor(value: number): `hsl(${number}, ${number}%, ${number}%)` {
        if (value < 1 || value > 43 || Number.isNaN(value) || value === null || value === undefined) {
            return 'hsl(40, 6%, 71%)'
        }
        const dataItem =this.data.find((item) => (item.rangeStart <= value) && (item.rangeEnd >= value))
        if (!dataItem) throw new Error('Value out of range')
        const currentSaturation = dataItem.colorStart.saturation + (dataItem.colorEnd.saturation - dataItem.colorStart.saturation) * ((value - dataItem.rangeStart) / (dataItem.rangeEnd - dataItem.rangeStart))
        const currentLightness = dataItem.colorStart.lightness + (dataItem.colorEnd.lightness - dataItem.colorStart.lightness) * ((value - dataItem.rangeStart) / (dataItem.rangeEnd - dataItem.rangeStart))
        return this.makeColor({hue: dataItem.colorStart.hue, saturation: currentSaturation, lightness: currentLightness})
    }


}

const data = [
    {
        rangeStart: 1,
        rangeEnd: 5,
        colorStart: {
            hue: 148,
            saturation: 1,
            lightness: 0.32,
        },
        colorEnd: {
            hue: 148,
            saturation: 1,
            lightness: 0.12,
        }
    },
    {
        rangeStart: 6,
        rangeEnd: 15,
        colorStart: {
            hue: 36,
            saturation: 0.95,
            lightness: 0.61,
        },
        colorEnd: {
            hue: 36,
            saturation: 0.6,
            lightness: 0.36,
        }
    },
    {
        rangeStart: 16,
        rangeEnd: 25,
        colorStart: {
            hue: 195,
            saturation: 0.83,
            lightness: 0.55,
        },
        colorEnd: {
            hue: 195,
            saturation: 0.68,
            lightness: 0.31,
        }
    },
    {
        rangeStart: 26,
        rangeEnd: 35,
        colorStart: {
            hue: 220,
            saturation: 0.92,
            lightness: 0.62,
        },
        colorEnd: {
            hue: 220,
            saturation: 0.58,
            lightness: 0.36,
        }
    },
    {
        rangeStart: 36,
        rangeEnd: 43,
        colorStart: {
            hue: 355,
            saturation: 0.78,
            lightness: 0.51,
        },
        colorEnd: {
            hue: 355,
            saturation: 0.75,
            lightness: 0.28,
        },
    },
]
